import { render, staticRenderFns } from "./WpItemsEditTabOverview.vue?vue&type=template&id=b2b78498&"
import script from "./WpItemsEditTabOverview.vue?vue&type=script&lang=js&"
export * from "./WpItemsEditTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./WpItemsEditTabOverview.vue?vue&type=style&index=0&id=b2b78498&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports